import React, { useEffect, useState } from 'react';
import { useNavigate, useLocation } from 'react-router-dom';

import { ROUTE_LOGIN } from 'src/utils/routes';
import { AUTH_REDIRECT_URI, AUTH_URL, BASIC_AUTH_CLIENT_ID, BASIC_AUTH_CLIENT_SECRET } from 'src/configs';
import { getFirstAccessibleRoute } from 'src/utils/permissions';
import { SIDEBAR_BUTTONS, SIDEBAR_MANAGEMENT_GROUP } from 'src/utils/constants';
import { useDispatch } from 'src/store/useDispatch';
import { fetchAdminProfile } from 'src/store/slice/adminSession';

import request from '../../request';
import { Loader } from 'src/components/Loader';

const CallbackPage = () => {
  const navigate = useNavigate();
  const dispatch = useDispatch();

  const createUrlSearchParams = (parameters: any) => {
    const params = new URLSearchParams();

    for (const key in parameters) {
      params.append(key, parameters[key]);
    }
    return params;
  };

  const getAccessToken = async (params: any) => {
    const response = await request.post(`${AUTH_URL}/token`, params, {
      auth: {
        username: BASIC_AUTH_CLIENT_ID,
        password: BASIC_AUTH_CLIENT_SECRET,
      },
      headers: {
        'Content-Type': 'application/x-www-form-urlencoded',
      },
    });
    return response;
  };

  const [result, setResult] = useState<any>();
  const [isLoading, setIsLoading] = useState(true);
  const queryParam = useLocation().search;
  const authorizationCode = new URLSearchParams(queryParam).get('code');

  useEffect(() => {
    if (!result && authorizationCode) {
      getAccessToken(
        createUrlSearchParams({
          grant_type: 'authorization_code',
          code: authorizationCode,
          redirect_uri: AUTH_REDIRECT_URI,
        }),
      )
        .then((res) => {
          setResult(res);
          localStorage.setItem('access', res?.data?.access_token);

          return dispatch(fetchAdminProfile())
            .unwrap()
            .then((admin) => {
              const route = getFirstAccessibleRoute(admin.permissions, SIDEBAR_BUTTONS, SIDEBAR_MANAGEMENT_GROUP);
              navigate(route ?? ROUTE_LOGIN, { replace: true });
            });
        })
        .catch((err) => {
          console.error('Authentication error:', err);
          navigate(ROUTE_LOGIN, { replace: true });
        })
        .finally(() => {
          setIsLoading(false);
        });
    } else if (!authorizationCode) {
      setIsLoading(false);
      navigate(ROUTE_LOGIN, { replace: true });
    }
  }, [authorizationCode, result, navigate, dispatch]);

  if (isLoading) {
    return <Loader overlay label="Signing you in..." />;
  }

  return <></>;
};

export default CallbackPage;
